<template>
  <div class="brand-history">
    <el-tabs v-model="activeName" @tab-click="navigate">
      <el-tab-pane label="Отзывы" name="BrandReviews"></el-tab-pane>
      <el-tab-pane label="Достижения" name="BrandAchievements"></el-tab-pane>
      <el-tab-pane label="Рекомендации" name="BrandRecommendations"></el-tab-pane>
    </el-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'BrandHistory',
  data () {
    return {
    }
  },
  methods: {
    navigate (tab, e) {
      this.$router.push({ name: tab.name })
    }
  },
  computed: {
    activeName () {
      return this.$route.name
    }
  }
}
</script>
<style>
.brand-history .el-tabs__nav {
  text-align: center;
  float: initial;
}
.brand-history .el-tabs__active-bar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// Index.vue?2287b1c1